/**
 * Lazy loads videos using IntersectionObserver
 * @param {string} selector - CSS selector for videos to lazy load (default: 'video.lazy')
 */
export function initLazyVideoLoader(selector = "video.lazy") {
    const lazyVideos = document.querySelectorAll(selector);

    if (!lazyVideos.length) {
        return;
    }

    if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    const sources = video.target.querySelectorAll("source");
                    sources.forEach(function (source) {
                        if (source.dataset.src) {
                            source.src = source.dataset.src;
                        }
                    });

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    } else {
        // Fallback for browsers without IntersectionObserver
        lazyVideos.forEach(function (video) {
            const sources = video.querySelectorAll("source");
            sources.forEach(function (source) {
                if (source.dataset.src) {
                    source.src = source.dataset.src;
                }
            });
            video.load();
            video.classList.remove("lazy");
        });
    }
}
